module.exports = __webpack_public_path__ + "static/img/dialogWarn.9ffabb3.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/dialogWarn.png
// module id = wuQC
// module chunks = 1